import React from 'react';

const PaymentMentions = () => {
  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4">
        <div className="bg-white rounded-xl p-8 border border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">{"Mentions Légales"}</h1>

          <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Éditeur du site"}</h2>
              <p>{"FormaPro Digital"}<br/>{"Site de vente de formations numériques"}<br/>{"Email : contact@formapro-digital.com"}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Hébergement"}</h2>
              <p>{"Le site est hébergé par des services d\u2019hébergement cloud professionnels assurant la disponibilité et la sécurité des données."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Activité"}</h2>
              <p>{"FormaPro Digital est spécialisé dans la vente de formations numériques en e-commerce et marketing digital. Les produits vendus sont exclusivement des contenus pédagogiques dématérialisés."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Prestataire de paiement"}</h2>
              <p>{"Les paiements sont traités de manière sécurisée par Stripe Payments Europe, Ltd., société agréée comme établissement de monnaie électronique par la Banque centrale d\u2019Irlande."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Propriété intellectuelle"}</h2>
              <p>{"L\u2019ensemble des éléments du site (textes, images, logos, vidéos, contenus de formation) sont protégés par le droit de la propriété intellectuelle. Toute reproduction totale ou partielle est strictement interdite sans autorisation préalable écrite."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Protection des données"}</h2>
              <p>{"Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d\u2019un droit d\u2019accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, contactez-nous par email."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Cookies"}</h2>
              <p>{"Le site utilise des cookies strictement nécessaires au fonctionnement du service. Aucun cookie de tracking publicitaire n\u2019est utilisé."}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMentions;
